import { apiHosts } from '../RestClient/FetchHelper.config';
import RestClient from '../RestClient/RestClient';

export const getHostConfig = (config) => {
    const context = RestClient.getContext();
    if (context && context.apiHosts && context.apiHosts[config.apiHost]) {
        config.host = context.apiHosts[config.apiHost];
        config.appHost = context.apiHosts.appHost;
        if (config && config.appHost && config.appHost.indexOf('test') === -1) {
            config.isXCloudHeaderRequired = false;
        }
    }
    return config;
};

export class RestConfig {
    static contentConfig = () => ({
        excludeVersion: true,
        apiHost: apiHosts.content,
        isXCloudHeaderRequired: true,
    });

    static v1SearchConfig = (credentials = 'include') => ({
        version: '/v1',
        apiHost: apiHosts.search,
        credentials,
    });

    static v1DraftConfig = () => ({
        version: '/order-api/v1',
        isAuthRequired: true,
        credentials: 'include',
        isXCloudHeaderRequired: true,
        contentType: 'application/json',
        apiHost: apiHosts.order,
        host: 'order-api-test.jcpenney.com',
    });

    static v1ImpulseConfig = () => ({
        version: '/v1',
        isAuthRequired: true,
        credentials: 'include',
        isXCloudHeaderRequired: true,
        contentType: 'application/json',
        apiHost: apiHosts.impulse,
        host: 'ordermanage-api-test.jcpenney.com',
    });

    static v1OrchestrationConfig = () => ({
        version: '/native-apps/v1',
        isAuthRequired: true,
        credentials: 'include',
        isXCloudHeaderRequired: true,
        contentType: 'application/json',
        apiHost: apiHosts.appHost,
        host: 'www.jcpenney.com',
    });

    static v3ImpulseConfig = () => ({
        version: '/v3',
        isAuthRequired: true,
        credentials: 'include',
        isXCloudHeaderRequired: true,
        contentType: 'application/json',
        apiHost: apiHosts.impulse,
        host: 'ordermanage-api-test.jcpenney.com',
    });

    static v5AccountConfig = () => ({
        url: '',
        version: '/v5',
        isAuthRequired: true,
        credentials: 'include',
        contentType: 'application/json',
        isXCloudHeaderRequired: true,
        acceptVersion: 5,
        apiHost: apiHosts.account,
        host: 'account-api-test.jcpenney.com',
    });

    static v1AccountConfig = () => ({
        url: '',
        version: '/v1',
        isAuthRequired: true,
        credentials: 'include',
        contentType: 'application/json',
        isXCloudHeaderRequired: true,
        acceptVersion: 5,
        apiHost: apiHosts.account,
        host: 'account-api-test.jcpenney.com',
    });

    static v1OmniWalletConfig = () => ({
        version: '/omni-wallet/v1',
        isAuthRequired: true,
        credentials: 'include',
        contentType: 'application/json',
        isXCloudHeaderRequired: true,
        apiHost: apiHosts.account,
        host: 'account-api-test.jcpenney.com',
    });

    static v1BrowseConfig = (credentials = 'include') => ({
        version: '/v1',
        credentials,
        contentType: 'application/json',
        apiHost: apiHosts.browse,
        host: 'browse-api-test.jcpenney.com',
    });

    static v1ApplePayConfig = () => ({
        version: '/order-api/v1',
        isAuthRequired: true,
        credentials: 'include',
        accept: 'application/json',
        isXCloudHeaderRequired: true,
        xStrategy: 'apple-pay',
        apiHost: apiHosts.order,
        host: 'order-api-test.jcpenney.com',
    });

    static pageLinkConfig = () => ({
        url: '',
        isAuthRequired: true,
        credentials: 'include',
        isXCloudHeaderRequired: true,
        contentType: 'application/json',
        external: true,
    });

    static externalCallConfig = () => ({
        url: '',
        isAuthRequired: false,
        credentials: 'omit',
        external: true,
    });
}

export default RestConfig;
